import React, { useState, useEffect, useRef }  from "react";
import { Container } from 'reactstrap';
import classnames from "classnames";

import DefaultAvatarImg from "~/assets/images/profile/defaultAvatar.png";

import Loader from "~/components/loader";

import Games    from '~/services/games.js';
import User     from "~/services/user";
import Security from "~/services/security";

const LeaderBoard = ({day, gameId})=> {


  const [loading        , setLoading]        = useState(false);
  const [leaderboardDay , setLeaderboardDay] = useState(day);
  const [rank           , setRank]           = useState([]);

  const [userRank       , setUserRank]       = useState(-1);
  const [avatar         , setAvatar]         = useState(DefaultAvatarImg);

  const playerRef  = useRef();
  const myRankRef  = useRef();

  let currentUser = Security.currentUserValue;

  useEffect(()=> {
    (async ()=> {
      const profile = await User.profile();
      setAvatar(profile ? profile.avatar : DefaultAvatarImg);
    })();
  }, []);

  useEffect(()=> {
    setLeaderboardDay(day);
  }, [day]);

  useEffect(()=> {
    (async ()=> {
      setLoading(true);
      const res = await Games.getRank(leaderboardDay, gameId);
      setRank(res.rank);
      setUserRank(res.userRank);
      setLoading(false);
    })();
  }, [leaderboardDay]);

  return (
    <Container className="leader-board">

      <div className="tab-switcher">
        <p className={classnames({"selected": leaderboardDay ==  0 })} onClick={()=> setLeaderboardDay(0)  }> Current Ranking </p>
        <p className={classnames({"selected": leaderboardDay == -1 })} onClick={()=> setLeaderboardDay(-1) }> Previous Winners </p>
      </div>

      { loading
        ? <Loader type={19} size={60} center className="m-t-50"/>
        : <div className="ranking">
          <div className="top-rank">
            <div>
              <span>2</span>
              <img className="small" src={rank[1]?.avatar || DefaultAvatarImg} />
              <p>{ rank[1]?.firstName } {rank[1]?.lastName || "-- Not claimed --"}</p>
              <p>{ rank[1]?.points || 0 } points</p>
            </div>
            <div>
              <span>1</span>
              <img className="big" src={rank[0]?.avatar  || DefaultAvatarImg} />
              <p>{ rank[0]?.firstName } {rank[0]?.lastName || "-- Not claimed --"}</p>
              <p>{ rank[0]?.points || 0 } points</p>
            </div>
            <div>
              <span>3</span>
              <img className="small" src={rank[2]?.avatar || DefaultAvatarImg} />
              <p>{ rank[2]?.firstName } {rank[2]?.lastName || "-- Not claimed --"}</p>
              <p>{ rank[2]?.points || 0 } points</p>
            </div>
          </div>

          <div className="players hide-scroll" ref={playerRef} style={{ maxHeight: window.innerHeight - (playerRef.current?.getBoundingClientRect().y || 0)  - (myRankRef.current?.getBoundingClientRect().height || 0) - 25 }}>
            { rank.map((item, index)=>
              <div className="player" key={index}>
                <div className="position">
                  {index+1}
                </div>

                <div className="avatar">
                  <img src={ item.avatar || DefaultAvatarImg } />
                </div>

                <div className="name">
                  <p>{ item.firstName } {item.lastName}</p>
                  <p>{ item.points } points</p>
                </div>
              </div>
            )}
          </div>

          { userRank != -1 && <div className="my-rank" ref={myRankRef}>
            <div className="me">
              <div className="position"> { userRank } </div>

              <div className="avatar"> <img src={ avatar } /> </div>

              <div className="name">
                <p>{ currentUser.firstName } {currentUser.lastName}</p>
                <p>{ rank.find((user)=> user.id == currentUser.id)?.points } points</p>
              </div>
            </div>
          </div> }
        </div> }

    </Container>
  );
};

export default LeaderBoard;
